import { useAppStore } from "@hooks/useAppStore";
import { MarkdownRenderer } from "@memorang/ui";
import type { MarkdownRendererProps } from "@memorang/ui/src/components/MarkdownRenderer";

const CustomMarkdownRenderer = (props: MarkdownRendererProps) => {
	const appFont = useAppStore((app) => app.app.font);
	return <MarkdownRenderer {...props} appFont={appFont} />;
};

export default CustomMarkdownRenderer;
